export default {
  computed: {
    viewport() {
      let viewport = {}
      const mqs = this.$store.state.globals.mq.length - 1
      const filtered =
        this.reverse === true
          ? this.layout.filter((entry) => entry.reverse)
          : this.layout.filter((entry) => !entry.reverse)

      // Emulates a CSS cascade to apply nearest layout object.
      for (let i = 0; i <= mqs; i++) {
        if (filtered[i] && filtered[i].size >= 0) {
          viewport = filtered[i]
          if (filtered[i].size >= this.$store.state.globals.size) {
            break
          }
        }
      }
      return viewport
    },
  },
}
